

<p-dialog [(visible)]="showEditTruckDialog" [modal]="true" [style]="{width: '450px'}" 
                [closeOnEscape]="false" [closable]="true" 
                [header]="'Edit Truck Assignment'">
    <div class="field">
      <label class="font-semibold mb-2 block">Truck Number</label>
      <p-dropdown [options]="trucks" [(ngModel)]="selectedTruckId" optionLabel="truck_number" optionValue="truck_id"
      [placeholder]="selectedTruckId ? 'Current truck selected' : 'Select a truck to assign'" [style]="{'width': '100%'}" [appendTo]="'body'" [filter]="true"
      [filterBy]="'truck_number'" [filterMatchMode]="'contains'" [filterFields]="['truck_number']" sortField="truck_number"></p-dropdown>
    </div>

    <ng-template pTemplate="footer">
      <div class="flex justify-content-end gap-2">
        <button pButton label="Cancel" icon="pi pi-times" class="p-button-outlined" (click)="showEditTruckDialog = false"></button>
        <button pButton label="Save" icon="pi pi-check" class="p-button-raised" (click)="saveEditTruck(selectedDriver)"></button>
      </div>
    </ng-template>
</p-dialog>


<p-dialog [(visible)]="showEditTrailerDialog" [modal]="true" [style]="{width: '450px'}" 
                [closeOnEscape]="false" [closable]="true" 
                [header]="'Edit Trailer'">

    <div class="field">
      <label class="font-semibold mb-2 block">Trailer</label>
      <p-dropdown [options]="trailers" [(ngModel)]="selectedTrailerId" optionLabel="trailer_number" optionValue="trailer_id"
      [placeholder]="selectedTrailerId ? 'Current trailer selected' : 'Select a trailer to assign'" [style]="{'width': '100%'}" [appendTo]="'body'" [filter]="true"
      [filterBy]="'trailer_number'" [filterMatchMode]="'contains'" [filterFields]="['trailer_number']" sortField="trailer_number"></p-dropdown>
    </div>

    <ng-template pTemplate="footer">
      <div class="flex justify-content-end gap-2">
        <button pButton label="Cancel" icon="pi pi-times" class="p-button-outlined" (click)="showEditTrailerDialog = false"></button>
        <button pButton label="Save" icon="pi pi-check" class="p-button-raised" (click)="saveEditTrailer()"></button>
      </div>
    </ng-template>
</p-dialog>

<!-- Include the assign-equipment component for internal functionality -->
<app-assign-equipment #equipmentAssigner 
  [drivers]="drivers" 
  [trucks]="trucks" 
  [trailers]="trailers" 
  style="display: none;">
</app-assign-equipment>